import React from "react";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import useIntercom from "@/hooks/useIntercom";

const ToolbarHelpButton: React.FC = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("sm"));

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);
  const handleClose = () => setAnchorEl(null);
  const handleClick = (event: React.MouseEvent<HTMLElement>) =>
    setAnchorEl(event.currentTarget);

  const { showChat } = useIntercom();

  return (
    <Box
      data-testid="toolbar-help-button"
      sx={[
        {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        isDesktop
          ? {
              width: 64,
            }
          : {
              width: 32,
            },
      ]}
    >
      <IconButton onClick={handleClick} size={isDesktop ? "medium" : "small"}>
        <HelpOutlineIcon fontSize={isDesktop ? "medium" : "small"} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 1,
          sx: {
            minWidth: 220,
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem
          onClick={() => {
            showChat();
            handleClose();
          }}
        >
          <Typography variant="body2">Get Help</Typography>
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default ToolbarHelpButton;
